// например: Пушкин Александр Сергеевич
export function getFullName(firstName, lastName, middleName) {
    // TODO? optimize?

    let result = "";

    if (lastName)
        result = lastName;

    if (firstName)
        result += result ? " " + firstName : firstName;

    if (middleName)
        result += result ? " " + middleName : middleName;

    return result;
}

// например: А. С. Пушкин
export function getShortName(firstName, lastName, middleName) {

    if (firstName && lastName && middleName)
        return `${getInitial(firstName)}. ${getInitial(middleName)}. ${lastName}`

    if (firstName && lastName)
        return `${getInitial(firstName)}. ${lastName}`

    if (firstName)
        return firstName;

    if (lastName)
        return lastName;

    return getFullName(firstName, lastName, middleName);
}

function getInitial(word) {
    if (word.toLocaleLowerCase().startsWith("дж"))
        return "Дж";

    return word[0];
}